import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  query getParentHierarchy($id: String!) {
    getParentHierarchy(id: $id) {
      items {
        organizationList {
          id
          name
        }
        level {
          id
          name
        }
        organizationId
      }
      error {
        statusCode
        message
      }
    }
  }
`;

const initialState: TYPES.OrganizationHierarchyListState = {
  result: null,
  error: null,
  loading: false
};

export const getParentHierarchyRequest = createAsyncThunk<
  TYPES.OrganizationHierarchyList,
  {id: String;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'organization/get_parent_hierarchy',
  async (params: {id: String;}, { extra: client }) => {
    try {
      const response = await client.query({
        query: GRAPHQL,
        variables: params
      });
      return response.data.getParentHierarchy;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const getParentHierarchySlice = createSlice({
  name: 'get_parent_hierarchy',
  initialState: initialState,
  reducers: {
    getParentHierarchyClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(getParentHierarchyRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(getParentHierarchyRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(getParentHierarchyRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { getParentHierarchyClear } =
getParentHierarchySlice.actions;

export const getParentHierarchy = createSelector(
  (state: RootState) => state.organization.getParentHierarchy.result,
  (state: RootState) => state.organization.getParentHierarchy.error,
  (state: RootState) => state.organization.getParentHierarchy.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default getParentHierarchySlice.reducer;